<template>
  <div class="container" v-if="items.length > 0">
    <template v-for="item in items">
      <ClassifyItem
        :key="item.id"
        :classify="item"
        :value="values[item.id]"
        :leftWidth="leftWidth"
        @change="onChange"
      ></ClassifyItem>
    </template>
    <slot name="date"></slot>
  </div>
</template>
<script>
import ClassifyItem from "./ClassifyItem.vue";
export default {
  name: "Classify",
  components: {
    ClassifyItem,
  },
  props: {
    items: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      values: {},
      leftWidth: 0,
    };
  },
  methods: {
    init() {
      let max = 0;
      this.items.forEach(item => {
        this.$set(this.values, item.id, item.value);
        if (max < item.name.length) {
          max = item.name.length;
        }
        this.leftWidth = max * 14;
      });
    },
    onChange({ id, value }) {
      this.$set(this.values, id, value);
      this.$emit("change", { id, value });
    },
  },
  created() {
    this.init();
    //52953
  },
  watch: {
    items() {
      this.init();
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  padding: 14px 20px 0 20px;
  background: white;
  border-radius: 5px;
}
</style>
